const API_ENDPOINTS = {
  prod: 'https://api.maxiot.com/v3/max/queryx/public/api/v1',
  pre: 'https://api.pre.maxiot.com/v3/max/queryx/public/api/v1',
} as const;

export type AppEnv = keyof typeof API_ENDPOINTS;

/** 构建时由 webpack DefinePlugin 注入，未设置则为 prod */
export const APP_ENV: AppEnv = process.env.APP_ENV === 'pre' ? 'pre' : 'prod';

export const API_BASE_URL = API_ENDPOINTS[APP_ENV];
